exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Modal__content___27su4 {\n  width: 100vw;\n  height: 100vh;\n  background-color: white;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  z-index: 11;\n}\n\n.Modal__closeIcon___34RPE {\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  right: 0;\n  margin-top: 20px;\n  margin-right: 20px;\n  cursor: pointer;\n}\n\n@media (min-width: 800px) {\n  .Modal__overlay___hDRUY {\n    z-index: 10;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    background-color: rgba(30, 37, 53, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .Modal__content___27su4 {\n    width: 440px;\n    border-radius: 5px;\n    height: auto;\n    position: relative;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"content": "Modal__content___27su4",
	"closeIcon": "Modal__closeIcon___34RPE",
	"overlay": "Modal__overlay___hDRUY"
};